import { __rest } from "tslib";
import React, { useRef, useState } from 'react';
import LxPopover from '@web-common/components/UI/LxPopover/LxPopover';
import { Popover, Tooltip } from 'antd';
import classnames from 'classnames';
import SiteLinkButtonEntry from '@web-edm/components/SiteLinkButtonEntry';
import IconCard from '@web-common/components/UI/IconCard';
import style from './editor.module.scss';
const HOCUtils = (Component) => {
    const EdUtils = (props) => {
        const { ref } = props, rest = __rest(props, ["ref"]);
        const [visible, setVisible] = useState(false);
        const [tipPos, setTipPos] = useState({
            top: 0,
            left: 0,
        });
        const [tempVisible, setTempVisible] = useState(false);
        const [interectShow, setInterectShow] = useState(false);
        const setVisibleRef = useRef(setVisible);
        const setTipPosRef = useRef(setTipPos);
        const fuRef = useRef(null);
        const quotationRef = useRef(null);
        const [siteLinkButtonVisible, setSiteLinkButtonVisible] = useState(false);
        setVisibleRef.current = setVisible;
        setTipPosRef.current = setTipPos;
        const utilsAction = button => {
            let elem = button;
            while (elem) {
                if (elem.className.includes('tox-toolbar__group')) {
                    break;
                }
                elem = elem.parentElement;
            }
            const elemRect = elem.getBoundingClientRect();
            setTipPosRef.current({
                top: elemRect.top + 41,
                left: elemRect.left,
            });
            setVisibleRef.current(true);
        };
        const onVaribleClickAction = () => {
            var _a;
            if ((_a = rest.init) === null || _a === void 0 ? void 0 : _a.onVaribleClickAction) {
                rest.init.onVaribleClickAction();
            }
        };
        const templateAct = type => {
            var _a;
            if ((_a = rest.init) === null || _a === void 0 ? void 0 : _a.comMailFormatAction) {
                rest.init.comMailFormatAction(type);
                setTempVisible(false);
            }
        };
        const signatureActionAction = () => {
            var _a;
            if ((_a = rest.init) === null || _a === void 0 ? void 0 : _a.signatureActionAction) {
                rest.init.signatureActionAction();
            }
        };
        const showProductTipAction = e => {
            var _a;
            if ((_a = rest.init) === null || _a === void 0 ? void 0 : _a.showProductTipAction) {
                rest.init.showProductTipAction();
            }
            e.stopPropagation();
        };
        const appendProductAction = () => {
            var _a;
            if ((_a = rest.init) === null || _a === void 0 ? void 0 : _a.appendProductAction) {
                rest.init.appendProductAction();
                setVisible(false);
            }
        };
        const appendLandingPageAction = () => {
            var _a;
            if ((_a = rest.init) === null || _a === void 0 ? void 0 : _a.appendLandingPageAction) {
                rest.init.appendLandingPageAction();
                setVisible(false);
            }
        };
        const salespitchActionAction = () => {
            var _a;
            if ((_a = rest.init) === null || _a === void 0 ? void 0 : _a.salespitchActionAction) {
                rest.init.salespitchActionAction();
                setVisible(false);
            }
        };
        const billShow = (type) => {
            var _a;
            if ((_a = rest.init) === null || _a === void 0 ? void 0 : _a.billShow) {
                rest.init.billShow(type);
                setVisible(false);
            }
        };
        const templateContent = (React.createElement("div", { className: classnames(style.template) },
            React.createElement("div", { className: classnames(style.tempI), onClick: () => {
                    templateAct(2);
                } }, "\u4E2A\u4EBA\u6A21\u7248"),
            React.createElement("div", { className: classnames(style.tempI), onClick: () => {
                    templateAct(4);
                } }, "\u4F01\u4E1A\u6A21\u7248"),
            React.createElement("div", { className: classnames(style.tempI), onClick: () => {
                    templateAct(3);
                } }, "\u63A8\u8350\u6A21\u7248")));
        const quotationContent = (React.createElement("div", { className: classnames(style.template) },
            React.createElement("div", { className: classnames(style.tempI), onClick: () => {
                    billShow('template');
                } }, "\u9009\u62E9\u5DF2\u5BFC\u51FA\u62A5\u4EF7\u5355"),
            React.createElement("div", { className: classnames(style.tempI), onClick: () => {
                    billShow('create');
                } }, "\u65B0\u5EFA\u62A5\u4EF7\u5355")));
        return (React.createElement(React.Fragment, null,
            React.createElement(Component, Object.assign({}, rest, { ref: ref, utilsAction: utilsAction })),
            React.createElement(LxPopover, { top: tipPos.top, left: tipPos.left, resetStyle: { zIndex: 999 }, visible: visible, setVisible: setVisible, acceptTopBottom: true },
                React.createElement("div", { className: style.mergeUtils },
                    React.createElement("div", { className: classnames(style.item), onClick: onVaribleClickAction },
                        React.createElement(IconCard, { type: "tongyong_renyuan7" }),
                        React.createElement("span", null, "\u63D2\u5165\u53D8\u91CF")),
                    React.createElement("div", { className: classnames(style.item, style.line) }),
                    React.createElement("div", { className: classnames(style.item), ref: fuRef },
                        React.createElement(Popover, { placement: "rightTop", content: templateContent, getPopupContainer: () => fuRef.current, zIndex: 1000 },
                            React.createElement("div", { className: classnames(style.triangle) },
                                React.createElement(IconCard, { type: "template2" }),
                                React.createElement("span", null, "\u6A21\u7248")))),
                    React.createElement("div", { className: classnames(style.item), onClick: signatureActionAction },
                        React.createElement(IconCard, { type: "signature" }),
                        React.createElement("span", null, "\u7B7E\u540D")),
                    React.createElement("div", { className: classnames(style.item, style.line) }),
                    React.createElement("div", { className: classnames(style.item), onClick: appendProductAction },
                        React.createElement(IconCard, { type: "product" }),
                        React.createElement("span", null, "\u5546\u54C1"),
                        React.createElement("span", { className: classnames(style.redPopu) }, "\u70ED\u95E8"),
                        React.createElement("span", { onClick: showProductTipAction, className: classnames(style.displayContent) },
                            React.createElement(IconCard, { type: "mannual" }))),
                    React.createElement("div", { className: classnames(style.item), onClick: appendLandingPageAction },
                        React.createElement(IconCard, { type: "marketPage" }),
                        React.createElement("span", null, "\u8425\u9500\u843D\u5730\u9875"),
                        React.createElement(Tooltip, { title: "\u63D2\u5165\u5728\u201C\u54C1\u724C\u5EFA\u8BBE\u201D\u4E2D\u521B\u5EFA\u7684\u8425\u9500\u843D\u5730\u9875\uFF0C\u5BA2\u6237\u8BBF\u95EE\u6216\u7559\u8D44\u540E\u5C06\u8BB0\u5F55\u5230\u7CFB\u7EDF" },
                            React.createElement(IconCard, { type: "mannual" }))),
                    React.createElement("div", { className: classnames(style.item), onMouseEnter: () => {
                            setInterectShow(true);
                        }, onMouseLeave: () => {
                            setInterectShow(false);
                        } },
                        React.createElement("div", { className: classnames(style.triangle) },
                            React.createElement(IconCard, { type: "activityBtn" }),
                            React.createElement("span", null, "\u4E92\u52A8\u6309\u94AE"),
                            React.createElement(Tooltip, { title: "\u63D2\u5165\u6309\u94AE\uFF0C\u5BA2\u6237\u70B9\u51FB\u540E\u5C06\u8DF3\u8F6C\u5230\u5546\u54C1\u6216\u8425\u9500\u843D\u5730\u9875" },
                                React.createElement(IconCard, { type: "mannual" })))),
                    React.createElement("div", { className: classnames(style.item), ref: quotationRef },
                        React.createElement(Popover, { placement: "rightTop", content: quotationContent, getPopupContainer: () => quotationRef.current, zIndex: 1000 },
                            React.createElement("div", { className: classnames(style.triangle) },
                                React.createElement(IconCard, { type: "priceList" }),
                                React.createElement("span", null, "\u62A5\u4EF7\u5355")))),
                    React.createElement("div", { className: classnames(style.item), onClick: salespitchActionAction },
                        React.createElement(IconCard, { type: "tongyong_jilu" }),
                        React.createElement("span", null, "\u8DDF\u5355\u8BDD\u672F\u5E93")))),
            React.createElement(SiteLinkButtonEntry, { getContainer: ".writePage-module-container", fromPage: "mail", visible: interectShow, setVisible: setInterectShow, mouseEnter: () => {
                    setInterectShow(true);
                }, mouseLeave: () => {
                    setInterectShow(false);
                }, pos: { top: tipPos.top + 209, left: tipPos.left + 146 }, mailInsertContent: (content) => {
                    var _a;
                    if ((_a = rest.init) === null || _a === void 0 ? void 0 : _a.insertTemplateToEditor) {
                        rest.init.insertTemplateToEditor(content);
                    }
                    setSiteLinkButtonVisible(false);
                } })));
    };
    return React.forwardRef((props, ref) => React.createElement(EdUtils, Object.assign({}, props, { ref: ref })));
};
export default HOCUtils;
